import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Order Totals component.
 */
export const defaultOrderTotalsAssets = {
    totalSavingsIconName: 'star'
};
export const orderTotalsAssetsValidatorSchema = {
    totalSavingsIconName: Validator.optional(nonEmptyStringValidator)
};
export const orderTotalsAssetsValidator = Validator.object(orderTotalsAssetsValidatorSchema);
